import baseService from '../../../lib/service/ServiceBase';
import { getVal } from '../../../lib/utils/UtilsCommon';

const PREFIX: string = 'LIVE_';

export const INIT_LIVE_DATA: string = PREFIX + 'INIT_LIVE_DATA';
export const INIT_LIVE_INFO: string = PREFIX + 'INIT_LIVE_INFO';
export const INIT_LIVE_SYMBOL: string = PREFIX + 'INIT_LIVE_SYMBOL';
export const SET_BANNER_LIST: string = PREFIX + 'SET_BANNER_LIST';
export const GET_CUSTOM_LIVEFUNCIONS: string = PREFIX + 'GET_CUSTOM_LIVEFUNCIONS';

/**
 * 初始化直播间信息
 */
export function initLiveData(data: any): any {
	return {
		type: INIT_LIVE_DATA,
		data,
	};
}

/**
 * 初始化直播间信息
 */
export function initLiveInfo(data: any): any {
	return {
		type: INIT_LIVE_INFO,
		data,
	};
}

/**
 * 初始化直播间信息
 */
export function initLiveSymbol(data: any): any {
	return {
		type: INIT_LIVE_SYMBOL,
		data,
	};
}

/**
 * 设置banner list
 */
export function setBannerList(data: any): any {
	return {
		type: SET_BANNER_LIST,
		data,
	};
}

/**
 * 获取自定义功能列表
 */
export function getCustomLiveFunctions(params: any): any {
	return async (dispatch: any, getStore: any): Promise<any> => {
		const result: any = await baseService.commonApi({
			url: '/api/wechat/transfer/h5/live/selfDefine/modules/list',
			body: {
				...params,
			},
		});
		if (getVal(result, 'state.code') === 0) {
			dispatch({
				type: GET_CUSTOM_LIVEFUNCIONS,
				payload: result.data.config && result.data.config.adminFunctionConfigDtoList,
			});
		}

		return result;
	};
}
